import React from 'react';
import tw from 'twin.macro';

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export default function Markdown({ text }: { text: string }) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      className="prose"
      children={text}
      components={{
        h1({ node, className, children, ...props }) {
          return (
            <h1 {...props} className={className} tw="text-xl mt-2 mb-3">
              {children}
            </h1>
          );
        },
        h2({ node, className, children, ...props }) {
          return (
            <h1 {...props} className={className} tw="text-lg mt-5 mb-3">
              {children}
            </h1>
          );
        },
        p({ node, className, children, ...props }) {
          return (
            <p {...props} className={className} tw="mt-2 font-jamjuree whitespace-pre-line">
              {children}
            </p>
          );
        },
        a({ node, className, children, ...props }) {
          return (
            <a {...props} className={className} tw="text-blue-500 underline hover:text-blue-600" target="_blank">
              {children}
            </a>
          );
        },
        ol({ node, className, children, ...props }) {
          return (
            <ol {...props} className={className} tw="list-decimal list-inside mt-2 font-jamjuree">
              {children}
            </ol>
          );
        },
        li({ node, className, children, ...props }) {
          return (
            <li {...props} className={className} tw="list-decimal list-inside mt-2 font-jamjuree">
              {children}
            </li>
          );
        }
      }}
    />
  );
}
